import { breakpoints, css } from '../../../styles/theme';
import { rem } from 'polished';

export const StylesDS = css`
    padding: ${rem(15)};

    &.collapsed-grid {
        max-height: ${rem(70)};
        overflow: hidden;
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(15)} ${rem(30)};
    }

    .mobile-filter-close-button {
        bottom: ${rem('-55px')};
    }

    .reset-filters--button {
        font-family: ${({ theme }) => theme.fonts.fontBase};
        font-style: normal;
        font-weight: normal;
        font-size: ${rem(16)};
    }

    .filter-grid__fuel,
    .filter-grid__gearbox {
        @media (min-width: ${breakpoints.md}px) {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            margin-left: ${rem(50)};
        }
    }

    .grid-button {
        position: relative;
        .info-check {
            position: absolute;
            right: ${rem(14)};
        }
    }

    .grid-button {
        position: relative;
        .info-check {
            position: absolute;
            right: ${rem(10)};
        }
    }

    .grid-button {
        position: relative;
        .info-check {
            position: absolute;
            right: ${rem(10)};
        }
    }

    .fuel-title {
        @media (min-width: ${breakpoints.md}px) {
            margin-left: ${rem(50)};
        }
    }

    .gearbox-title {
        @media (min-width: ${breakpoints.md}px) {
            margin-left: ${rem(50)};
        }
    }

    .frontpage-legaltext {
        @media (min-width: ${breakpoints.md}px) {
            margin: 1rem 0 0 0;
        }
    }
`;
